interface Props {
  oidcIssuer: string | null
}

export default function OidcLoginButton({ oidcIssuer }: Props) {
  function handleSsoLogin() {
    window.location.href = '/api/auth/oidc/authorize'
  }

  return (
    <div className="space-y-4">
      <button
        onClick={handleSsoLogin}
        className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow hover:bg-primary/90"
      >
        Sign in with SSO
      </button>
      {oidcIssuer && (
        <p className="text-center text-xs text-muted-foreground font-mono truncate">
          {oidcIssuer}
        </p>
      )}
    </div>
  )
}
